import { NgTemplateOutlet } from "@angular/common";
import { booleanAttribute, ChangeDetectionStrategy, Component, contentChildren, input, model, TemplateRef, viewChild } from "@angular/core";
import { Step, StepList, StepPanel, StepPanels, Stepper } from "primeng/stepper";

@Component({
    selector: "kno2-step",
    template: `
        <ng-template #body>
            <ng-content />
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepComponent {
    public readonly value = input.required<number>();
    public readonly header = input<string>();
    public readonly bodyTemplate = viewChild.required<TemplateRef<unknown>>("body");
}

@Component({
    selector: "kno2-stepper",
    imports: [Stepper, StepList, Step, StepPanels, StepPanel, NgTemplateOutlet],
    template: `
        <p-stepper
            [value]="value()"
            (valueChange)="value.set($any($event))"
            [linear]="linear()">
            <p-step-list>
                @for (step of steps(); track step.value()) {
                    <p-step [value]="step.value()">{{ step.header() }}</p-step>
                }
            </p-step-list>
            <p-step-panels>
                @for (step of steps(); track step.value()) {
                    <p-step-panel [value]="step.value()">
                        <ng-template #content>
                            <ng-container [ngTemplateOutlet]="step.bodyTemplate()" />
                        </ng-template>
                    </p-step-panel>
                }
            </p-step-panels>
        </p-stepper>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {
    public readonly value = model<number>();
    public readonly linear = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly steps = contentChildren(StepComponent);
}
